import { TagV2Variant } from '@zola/zola-ui/src/components/Tag/TagV2.styles';

// will need to update depending on what the actual data from BE is
export const getTagColor = (color: string): TagV2Variant => {
  if (color === '#0F5C82') {
    return TagV2Variant.BAY;
  }
  if (color === '#77133F') {
    return TagV2Variant.WINE;
  }
  return TagV2Variant.WHITE;
};
